<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">My Sales Team 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="7">
              <b-input-group >
                  <b-input-group-prepend><span class="p-2">Atasan Langsung</span></b-input-group-prepend>
                  <b-form-input v-model="filter.parentname"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="showLkuUser('filter.parentname')" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>

                  <b-input-group-prepend><span class="p-2">Child status</span></b-input-group-prepend>
                  <b-form-select v-model="tblData.directchild" :plain="true" :options="childStatuses"></b-form-select>
              </b-input-group>
        </b-col>
        <b-col lg="4">
              <b-row>
                <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-row>
        </b-col>

      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>
        <template v-slot:cell(empty)="scope">
              <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
            <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="8" lg="6">
        <b-card >
            <div slot="header">Add Team Form 
              <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
              </div>
            </div>
            <b-input-group >
              <b-input-group-prepend><label>Atasan Langsung</label></b-input-group-prepend>
                <b-form-input readonly v-model="frmdata.parentname" :state="!$v.frmdata.parentname.$error"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="showLkuUser('frmdata.parentname')" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Team dibawahnya</label></b-input-group-prepend>
                <b-form-input readonly v-model="frmdata.username" :state="!$v.frmdata.username.$error"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="showLkuUser('frmdata.username')" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group>
        </b-card>
      </b-col>
    </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of Users" :centered="true">
        <lku-user @click="onSelectUser"></lku-user>
    </b-modal>        
  </div>
</template>


<script>
import lkuUser from "../lookup/lkuUser";
import toastr from "mini-toastr";
import crud from "../../apis/salesteam";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuUser},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        username: { required },
        parentname: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      lkuUserShow:false,
      lkuUserCaller:'filter.username',
      filter:{username:''},
      frmdata:{parentname: '', username: '' },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        parentname: this.$store.state.user.username,
        sortBy: null,
        sortDesc: false,
      },
    tblFields:[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "parentname",
            label: "Atasan langsung",
            sortable: true
          },
          {
            key: "username",
            label: "Team dibawahnya",
            sortable: true
          },
          {
            key: "email",
            label: "Email"
          },
          {
            key: "mobile",
            label: "Mobile Phone",
            sortable: true
          },
          {
            key: "directchild",
            label: "Direct Child",
            sortable: true
          },          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
        ],
      childStatuses:[{value:'1', text:'Direct Child'}, {value:'0', text:'Indirect Child'}, {value:'', text:'---ALL---'}]
    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },  
  // created: async function(){
  // },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);     
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.filter.parentname= '';
        this.refresh();
    },

    add: function() {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      // this.frmdata.username=this.filter.username
      this.showForm=true;
      this.showList=false;
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      try {
        await crud.remove(this.model);
        this.refresh();
      } catch (error) {
           console.log(error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }              
      }
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuUser(callerObj)
    {
      this.lkuUserShow=true;
      this.lkuUserCaller=callerObj;
    },
    async onSelectUser(_selected) {
      const arrCaller=this.lkuUserCaller.split('.');
        this[arrCaller[0]][arrCaller[1]] = _selected.username;;
        // this.filter.full_name = _selected.full_name;
        this.lkuUserShow=false;
    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
          try {
            await crud.save(this.frmdata);            
            setTimeout(() => {
                this.refresh();              
            }, 500);       
            this.showForm=false;
            this.showList=true;
          } catch (error) {
              console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }              
          }
        }
    }, 
    closeFrm(){
            this.showForm=false;
            this.showList=true;
    },
    close(){
      router.push("home");
    },    
  }
};
</script>
